import '@formatjs/intl-durationformat/polyfill.js';
import 'temporal-polyfill/global';

if (!Symbol.dispose) {
  Object.assign(Symbol, { dispose: Symbol('Symbol.dispose') });
}

if (!Symbol.asyncDispose) {
  Object.assign(Symbol, { asyncDispose: Symbol('Symbol.asyncDispose') });
}
